module.exports = __webpack_public_path__ + "img/icon_next.779d2a97.svg";